import * as Yup from "yup";

import { validationObject as insuranceOwnerValidationObject } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/validation";
import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { UsabilityCode } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Motorcycle";
import { MotorcycleProductDetailsFormValues } from "../motorcycleInterface";

export const validationSchema =
  (): Yup.ObjectSchema<MotorcycleProductDetailsFormValues> => {
    const { getText } = TextManager;

    return Yup.object()
      .shape({
        ...insuranceOwnerValidationObject(),
        usabilityCode: Yup.mixed<UsabilityCode>().required(
          getText("motorcycleform.validation.usabilitycode"),
        ),
        mortgagee: Yup.mixed<BooleanFormType>().required(
          getText("motorcycleform.validation.mortgagee"),
        ),
        mcLocker: Yup.mixed<BooleanFormType>().required(
          getText("motorcycleform.validation.mclocker"),
        ),
        garage: Yup.mixed<BooleanFormType>().required(
          getText("motorcycleform.validation.garage"),
        ),
      })
      .concat(getInjuriesSchema());
  };
